import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { consulta, mostrarError, rutaImg } from "../../../global/js/funciones";


//COMPONENTES GENERALES
import { mostrarModulo } from "../../../redux/actions/actGlobal";
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import ListarDatos from '../../general/ListarDatos';
import { BtnForm, BtnPermiso, BtnRegresar } from '../../general/BotonesAccion';
import Asignar_Asignatura from './Asignar_Asignatura';
import { Dialog, DialogActions, DialogContent, Grid, Paper } from '@material-ui/core';
import TituloAccion from '../../general/TituloAccion';
import AccionesRapidas from '../../general/AccionesRapidas';
import permisosIcon from '../../../global/imagenes/lightbulb.png';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import AppBarModal from '../../general/AppBarModal';
import BuscarPersona from '../../general/BuscarPersona';
import SisefEstudiante from '../SisefEstudiante';

class Sisef_Gestion extends Component {

  constructor(props) {
    super(props)
    this.state = {
      seleccion: 'admin',
      cargando: false,
      mensajeCargando: 'Cargando..',
      nuevo: true,
      asignar: false,
      data: {},
      mensaje: '',
      tipoSolicitud: {},
      docentes: [],
      modalBuscarEstudiante: false,
      persona: {},
    }
    this.toggleDialog = this.toggleDialog.bind(this)
  }

  async componentDidMount() {
    let { mostrarModulo } = this.props;
    mostrarModulo({ rutas: 'gestion_sisef', nombre: 'Gestión MENTORA' })
  }

  async componentDidUpdate({ }, { seleccion }) {
    let { seleccion: seleccionNew } = this.state;
    if (seleccion !== seleccionNew) {
      if (seleccionNew === 'listaDoc') {
        this.setState({ nuevo: true })
        await this.obtenerDatosIniciales();

      }
    }
  }

  cambiarEstado = (estados) => {
    this.setState(estados)
  }

  cambiarOpcion = (seleccion) => {
    this.cambiarEstado({ seleccion })
  }

  toggleDialog(toggle) {
    let { modal, value } = toggle
    this.setState({ [modal]: value })
  }

  async obtenerDatosIniciales() {
    let { docentes } = this.state
    this.setState({ cargando: true })
    docentes = await this.obtenerDocentes("Per_Doc");
  //  let todosDocentes = await this.obtenerDocentesTodos();
  //   console.log("todosDocentes", todosDocentes);
    let mensaje = "Estas en el proceso";
    this.setState({ mensaje, cargando: false, docentes })
  }

  async obtenerDocentes(cod) {
    return new Promise(resolve => {
      consulta(`api/v1.0/sisef/buscar_docentes/${cod}`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  async obtenerDocentesTodos() {
    return new Promise(resolve => {
      consulta(`api/v1.0/sisef/listarDocentesSisef`, null, null, (error, estado, resp) => {
        resolve(estado === 200 && !error ? resp : null);
      })
    })
  }

  async asignarRelacionDocente() {
    consulta(`api/v1.0/sisef/asignar_asignaturaMultiple`, {}, "post", (error, estado, resp) => {
      let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
      if (!error) {
        if (estado === 200) {
          tipo = 'success';
          titulo = resp.titulo;
          // this.VerificarAsignaturas();
        } else {
          tipo = 'info';
          titulo = resp.titulo ? resp.titulo : mostrarError(resp);
        }
      }
      // actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
    });
  }

  vista() {
    let { seleccion, modalBuscarEstudiante } = this.state
    return (
      <>
        {seleccion !== 'admin' && <div className={'regresar'} ><BtnRegresar callback={() => this.setState({ seleccion: 'admin', modalBuscarEstudiante: (seleccion == 'vistaEstudiante') ? true : false })} /></div>}
        {seleccion === 'admin' && this.pintarInicioAdm()}
        {seleccion === 'listaDoc' && this.pintarListaDocentes()}
        {modalBuscarEstudiante && this.buscarEstudiante()}
        {seleccion == 'vistaEstudiante' && this.pintarVistaEstudiante()}
      </>
    )
  };


  pintarInicioAdm = () => {
    let { administrador } = this.props;
    return (
      <div style={{ padding: '4% 2% 0% 2%' }}>
        <Grid container direction={'row'} spacing={1} justifyContent={'center'}>
          <Grid item xs={12} sm={12} md={10} lg={10}>
            <TituloAccion principal='' alterno='¿ Qué deseas hacer ?' />
            <Paper elevation={0} square className='scroll contenido_fijo'>
              <Grid container direction={'row'} spacing={1} style={{ width: "100%" }}>
                <Grid item xs={12} sm={12} md={6} lg={6} >
                  <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ seleccion: 'listaDoc' })}>
                    <AccionesRapidas imagen={permisosIcon} titulo='¡ Permisos docente !' sub_titulo='' des_sub_titulo='Asigna, modifica y elimina las asignaturas a los docentes.' />
                  </Paper>
                </Grid>
                {
                  administrador &&
                  <Grid item xs={12} sm={12} md={6} lg={6} >
                    <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => this.setState({ modalBuscarEstudiante: true })}>
                      <AccionesRapidas imagen={permisosIcon} titulo='¡ Vista estudiante !' sub_titulo='' des_sub_titulo='Busca y ten una vista del modulo mentora estudiante.' />
                    </Paper>
                  </Grid>
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }

  acciones(rowData) {
    const Asignar_Asignatura = (row) => {
      this.setState({ asignar: true, data: row })
    }
    return <div> <BtnPermiso texto="Asinar Asignaturas" callback={() => Asignar_Asignatura(rowData)} /></div>;
  }

  // accionAsignar = async () => {
  //   console.log("Hola")
  //   this.setState({ cargando: true, mensajeCargando: 'Creando relación Asignatura - Docente... Por favor espere' })
  //   await this.asignarRelacionDocente()
  //   this.setState({ cargando: false, mensajeCargando: 'Cargando...' })
  // }

  // accionAsignar = async () => {
  //   console.log("Hola");
  //   this.setState({ cargando: true, mensajeCargando: 'Creando relación Asignatura - Docente... Por favor espere' })

  //   await new Promise(resolve => setTimeout(resolve, 15000)); // Simula 1 minuto de espera

  //   await this.asignarRelacionDocente(); // Llamada real después del minuto

  //   this.setState({ cargando: false, mensajeCargando: 'Cargando...' })
  //   console.log("Proceso terminado después de 1 minuto.");
  // };

  // NUEVO ASIGNAR EN LOTE
  accionAsignarMultiple = async () => {
    console.log("Iniciando proceso de asignación por lotes...");
    this.setState({
      cargando: true,
      mensajeCargando: 'Asignando asignaturas a docentes... Por favor espere',
    });

    let offset = 0;
    const limit = 500;
    let cargando = true;
    let max_data = 0;

    try {
      do {
        const url = `api/v1.0/sisef/asignar_asignaturaMultiple?limit=${limit}&offset=${offset}`;
        console.log(`Llamando a: ${url}`);

        const respuesta = await new Promise((resolve, reject) => {
          consulta(url, {}, "post", (error, estado, resp) => {
            if (estado === 200) resolve(resp);
            else reject(error || 'Error en asignación');
          });
        });

        offset += limit;
        max_data = respuesta.max_data || 0;

        if (offset >= max_data) cargando = false;
      } while (cargando);

      this.setState({ cargando: false, mensajeCargando: 'Cargando...' });
      console.log("Proceso de asignación completado.");
    } catch (error) {
      console.error("Error durante la asignación:", error);
      this.setState({ cargando: false, mensajeCargando: 'Cargando...' });
    }
  };


  pintarListaDocentes = () => {
    let { docentes, asignar, data } = this.state

    return (
      <>
        <ListarDatos
          id='tbl_lista_docentes'
          datos={docentes}
          acciones={(row) => this.acciones(row.persona)}
          opciones={true}
          titulo='Profesores'
          buscar={true}
          filtrar={false}
          avatar={(persona) => `${rutaImg}${persona.identificacion}.jpg`}
          fila_principal={({ persona }) => `${persona.primer_nombre} ${persona.segundo_nombre} ${persona.primer_apellido} ${persona.segundo_apellido}`.toUpperCase()}
          filas={[
            {
              'mostrar': ({ persona }) => `${persona.identificacion}`,
              'id': 'identificacion', 'enLista': true
            },
          ]}
          opcionExtra={true}
          propsOpExtra={{ tituloOpEx: 'Relacionar Docente y Asignaturas', iconoOpExtra: <AutorenewIcon />, actOpExtra: () => this.accionAsignarMultiple() }}
        />
        <Asignar_Asignatura
          Modal={asignar}
          cerrarModal={(resp) => this.setState({ asignar: resp })}
          data={data}
        />
      </>
    );
  };

  pintarVistaEstudiante = () => {
    let { persona: { identificacion } } = this.state;
    return (
      <>
        <SisefEstudiante vistaAdmin={true} identificacion={identificacion} />
      </>
    )
  }

  buscarEstudiante = () => {
    let { modalBuscarEstudiante } = this.state;

    return (
      <Dialog fullWidth={true} maxWidth='sm' open={modalBuscarEstudiante} onClose={() => this.setState({ modalBuscarEstudiante: false })} aria-labelledby="form-dialog-title">
        <AppBarModal titulo="Lista de personas" mostrarModal={() => this.setState({ modalBuscarEstudiante: false })} titulo_accion="Mostrar Asignaturas" accion="" />
        <DialogContent className='scroll'>
          <BuscarPersona
            callback={({ id, identificacion, correo }) => this.setState({ persona: { id, identificacion, correo }, seleccion: 'vistaEstudiante', modalBuscarEstudiante: false })}
          />
        </DialogContent>
        <DialogActions>
          <BtnForm texto="CANCELAR" callback={() => this.setState({ modalBuscarEstudiante: false })} />
        </DialogActions>
      </Dialog>
    )
  }

  render() {
    let { cargando, mensajeCargando } = this.state
    return (
      <div >
        {
          !cargando ? this.vista() :
            <TareasTerminadas mensaje={mensajeCargando} marginTop='9%' imagen={emma_w} widthImg="10%" cargando={true} />
        }
      </div>

    );
  }
}
const mapStateToProps = state => {
  let { usuario } = state.redGlobal;
  let { ModalAdd } = state.redSisef;
  return { usuario, ModalAdd }
}

const mapDispatchToProps = {
  mostrarModulo
}

Sisef_Gestion.propTypes = {
  //Funciones
  ModalAdd: PropTypes.bool.isRequired,
  mostrarModulo: PropTypes.func.isRequired,
}


export default connect(mapStateToProps, mapDispatchToProps)(Sisef_Gestion);